export const NO_OWNERSHIP = "0";
export const OWNERSHIP_LESS_THAN_25 = "1";
export const OWNERSHIP_OVER_25 = "2";

export default Object.freeze({
  [NO_OWNERSHIP]: "N/A",
  [OWNERSHIP_LESS_THAN_25]: "Ownership share of less than 25%",
  [OWNERSHIP_OVER_25]: "Onwership share of 25% or more"
});
